/* eslint-disable */
import Swiper from 'swiper';
import { A11y, Keyboard, Navigation, Pagination } from 'swiper/modules';

export default function floorPlansSlider() {
  const floorPlansSliders = document.querySelectorAll('.floor-plans-slider');

  floorPlansSliders.forEach((floorPlansSlider) => {
    const caption = floorPlansSlider.closest('.tab')?.querySelector('.floor-plans-caption');

    // Swap the tab subtitle for the active slide's image caption (falls back to the tab subtitle).
    const updateCaption = (swiper) => {
      if (!caption) return;
      const text = swiper.slides[swiper.activeIndex]?.dataset.caption || caption.dataset.default || '';
      caption.textContent = text;
      caption.hidden = !text;
    };

    const slider = new Swiper(floorPlansSlider, {
      modules: [A11y, Keyboard, Navigation, Pagination],
      loop: true,
      spaceBetween: 22,
      slidesPerView: 1,
      keyboard: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
        addIcons: false,
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
      },
      a11y: {
        scrollOnFocus: false,
      },
      watchSlidesProgress: true,
      on: {
        slideChange: (swiper) => {
          updateCaption(swiper);
          swiper.slides.forEach((slide) => {
            if (slide.classList.contains('swiper-slide-visible')) {
              slide.removeAttribute('inert');
            } else {
              slide.setAttribute('inert', '');
            }
          });
        }
      }
    });
  });
}
